import service from './service'
import { CONTENT_TYPE } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import type { RequestConfig } from './types'
import { getVersionConfig } from './preRequest'
import md5 from 'js-md5'

// 文件上传等获取请求头
export const getHeader = async () => {
  const userStore = useUserStoreWithOut()
  const permissionStore = usePermissionStoreWithOut()
  const timestamp = new Date().getTime()
  const header = {
    platformtype: 'web',
    timestamp,
    sign: md5(JSON.stringify(null) + timestamp + (userStore.getToken ?? '')),
    appId: 'haili001',
    resourceCode: permissionStore.getCurrentEntryCode,
    [userStore.getTokenKey ?? 'Authorization']: userStore.getToken ?? ''
  }
  try {
    const versionData = await getVersionConfig()
    if (versionData.url) {
      header.versionDay = versionData.versionDay
    }
  } catch (e) {
    console.log(e)
  }
  return header
}

const request = (option: RequestConfig) => {
  const {
    url,
    method,
    params,
    data,
    headers,
    responseType,
    transformResponse,
    hideLoading,
    hideMsg,
    baseURL
  } = option
  const userStore = useUserStoreWithOut()
  const permissionStore = usePermissionStoreWithOut()
  const timestamp = new Date().getTime()
  return service.request({
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    transformResponse,
    baseURL,
    headers: {
      serverCode: 'bi',
      'Content-Type': CONTENT_TYPE,
      'local-language': 'zh-CN', // zh-CN ; en-US
      platformtype: 'web',
      appId: 'haili001',
      [userStore.getTokenKey ?? 'Authorization']: userStore.getToken ?? '',
      timestamp,
      sign: md5(JSON.stringify(data || null) + timestamp + (userStore.getToken ?? '')),
      // [userStore.getTokenKey ?? 'Authorization']:
      //   'eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50SWQiOjMsImFjY291bnRDb2RlIjoiYWRtaW5xeCIsImFjY291bnROYW1lIjoiYWRtaW5xeCIsInRlbE51bSI6IjE1OTE5NDQ1MTA2IiwiZXhwIjoxNzUzNDk5ODY0LCJpYXQiOjE3MjIzOTU4NjQsInBsYXRmb3JtIjoiYmlNYW5hZ2UifQ.X-Njmpdp1aXqXMX30slFRGx8BLdANciDeC1eFZhTXgKFgqVRe63V4gwzAy3ss0zKeVI5xX2LNtY1inPbMK5Hqg',
      outer: 'web',
      resourceCode: permissionStore.getCurrentEntryCode,
      ...headers
    },
    hideLoading,
    hideMsg
  })
}

export default {
  get: <T = any>(option: RequestConfig) => {
    return request({ method: 'get', ...option }) as Promise<IResponse<T>>
  },
  post: <T = any>(option: RequestConfig) => {
    return request({ method: 'post', ...option }) as Promise<IResponse<T>>
  },
  delete: <T = any>(option: RequestConfig) => {
    return request({ method: 'delete', ...option }) as Promise<IResponse<T>>
  },
  put: <T = any>(option: RequestConfig) => {
    return request({ method: 'put', ...option }) as Promise<IResponse<T>>
  },
  cancelRequest: (url: string | string[]) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  }
}
